import {Component, Input, OnInit} from '@angular/core';
import {MesswertMeteogroupRbb} from '../../../../../model/messwerte/messwert-meteogroup-rbb';
import {BundesLandName} from '../../../../../model/component/bundesland';
import {BundeslandFilterService} from '../../../../../service/bundeslandFilter/bundesland-filter.service';
import {FirebaseService} from '../../../../../service/firebase/firebase.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FreizeitWetter} from '../../../../../model/vorhersagen/freizeit-wetter';
import {take} from 'rxjs/operators';
import {Astrowetter} from '../../../../../model/messwerte/astrowetter';
import {MatTabChangeEvent} from '@angular/material/tabs';

@Component({
  selector: 'app-freizeit-wetter',
  templateUrl: './freizeit-wetter.component.html',
  styleUrls: ['./freizeit-wetter.component.css']
})
export class FreizeitWetterComponent implements OnInit {

  //Wäre dann für allgemeines Wetter
  freizeitWetter: FreizeitWetter = new FreizeitWetter();



  constructor() {
  }

  ngOnInit(): void {
  }



}
